import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../data/site";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Air Con", href: "#aircon" },
  { label: "Roamwire", href: "#roamwire" },
  { label: "Reviews", href: "#reviews" },
  { label: "About", href: "#about" },
  { label: "FAQ", href: "#faq" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[rgba(11,15,23,0.85)] backdrop-blur-xl border-b border-line"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 h-[72px] flex items-center justify-between gap-4">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 shrink-0"
          aria-label="SWS Auto Electrics & Air Conditioning — back to top"
        >
          <img
            src="/sws-logo.webp"
            alt="SWS Auto Electrics & Air Conditioning logo"
            className="h-11 w-auto"
            width={138}
            height={44}
          />
        </a>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Section links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 hover:text-orange-500 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={PHONE_TEL}
          data-testid="nav-call-button"
          className="shrink-0 inline-flex items-center gap-2 rounded-full bg-orange-600 hover:bg-orange-500 text-ink font-semibold text-sm px-4 sm:px-5 h-11 transition-colors"
        >
          <Phone size={16} strokeWidth={2.5} />
          <span className="hidden sm:inline">Call Sam</span>
          <span className="sm:hidden">Call</span>
          <span className="hidden md:inline font-mono font-medium text-ink/80">
            {PHONE_DISPLAY}
          </span>
        </a>
      </div>
    </header>
  );
};
